import { UserLogged } from '../models/UserLogged';
import { UserRoleEnum } from '../enums/User/UserRoleEnum';

export interface ChatFeatureConfig {
  id: string;
  label: string;
  icon: string;
  iconVariant?: string;
  enabled: boolean;
  payload?: string;
  permissionCheck: (user: UserLogged) => boolean;
}

export const chatFeatures: ChatFeatureConfig[] = [
  {
    id: 'consulta-livre',
    label: 'Consulta Livre',
    icon: 'chat',
    enabled: true,
    permissionCheck: () => true,
  },
  {
    id: 'simular-proposta',
    label: 'Simulação de proposta',
    icon: 'description',
    enabled: true,
    permissionCheck: (user) => user.role === UserRoleEnum.ADMIN,
  },
  {
    id: 'consulta-propostas',
    label: 'Consulta de Propostas',
    icon: 'queryStats',
    enabled: true,
    payload: 'Quero consultar o status de uma proposta no INSS',
    permissionCheck: (user) => user.role === UserRoleEnum.ADMIN,
  },
  {
    id: 'pre-digitacao-aumento-margem-inss',
    label: 'Pré-digitação do Aumento de Margem INSS',
    icon: 'moneyUp',
    enabled: true,
    permissionCheck: () => true,
  },
  {
    id: 'consulta-login-banco',
    label: 'Consulta de Login Banco',
    icon: 'lockPerson',
    enabled: true,
    payload: 'Consultar status de protocolo de login do banco',
    permissionCheck: (user) => user.role === UserRoleEnum.ADMIN,
  },
];
